import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCollapseVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 7 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.816667 11.6667L0 10.85L3.5 7.35L7 10.85L6.18333 11.6667L3.5 8.98333L0.816667 11.6667ZM3.5 4.31667L0 0.816667L0.816667 0L3.5 2.68333L6.18333 0L7 0.816667L3.5 4.31667Z",
		fill: "currentColor"
	})
});
export default SvgCollapseVertical;
